export const GC_AWARDS_API = process.env.REACT_APP_GC_AWARDS_API;
export const GC_AWARDS_LOGIN = process.env.REACT_APP_MULTIGAMING_URL;
